<template>
  <router-view/>
</template>

<style src="./App.scss" lang="scss"></style>
